<template>
  <transition mode="out-in" name="fade-transform">
    <keep-alive :include="cachedViews">
      <router-view :key="key"/>
    </keep-alive>
  </transition>
</template>

<script lang="ts" setup>
import {computed} from 'vue';
import {useStore} from 'vuex';

const store = useStore();

const cachedViews = computed(() => store.state.tagsView.cachedViews);
const key = computed(() => store.state.route.fullPath);
</script>

<style>
.v-application ul,
.v-application ol {
  padding-left: 0 !important;
}

.options-subtitle {
  line-height: 1.2;
  color: rgba(255, 255, 255, 0.7);
  font-size: 1rem;
  margin-top: 5px;
}
</style>
